import { render, staticRenderFns } from "./GrowthStagesSteps.vue?vue&type=template&id=53e6ead2&scoped=true"
import script from "./GrowthStagesSteps.vue?vue&type=script&lang=ts"
export * from "./GrowthStagesSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6ead2",
  null
  
)

export default component.exports